import React from 'react';
import { Table, Empty, Button, Input, Checkbox, Form, Tooltip, DatePicker, Icon } from 'antd';
import { FORMAT_NUMBER_NO_ZERO, FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS } from '../../../../common/types/regularExpresionType';
import moment from 'moment';
import { VALIDAR_STOCK } from '../../../../common/types/parametroType'
import auth from '../../../../common/utility/auth';

export default function Servicios (props) {

    
    return (
        <div>
            <Table
                className={'table-servicios'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.id}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}

                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 40,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row.id)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Id',
                        dataIndex: 'id',
                        key: 'id',
                        align: 'center',
                        width: 80,
                        ellipsis: true
                    },
                    {
                        title: 'Servicio',
                        dataIndex: 'nombre',
                        key: 'nombre',
                        width: 300,
                        ellipsis: true
                    },
                    {
                        title: 'Tipo Cambio',
                        dataIndex: 'tipoCambio',
                        key: 'tipoCambio',
                        align: 'left',
                        width: 150,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrTipoCambio[${row.id}]`, {
                                        initialValue: value,
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_3DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Lote"
                                            autoComplete="off"
                                            className="text-left"
                                            onBlur={(e) => props.onCalculateServicio(row.id, "arrTipoCambio", e.target.value, 3, row.id)}
                                            disabled={row.isReadOnly}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Soles',
                        dataIndex: 'soles',
                        key: 'soles',
                        align: 'left',
                        width: 150,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrSoles[${row.id}]`, {
                                        initialValue: value,
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_3DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Lote"
                                            autoComplete="off"
                                            className="text-left"
                                            onBlur={(e) => props.onCalculateServicio(row.id, "arrSoles", e.target.value, 3, row.id)}
                                            disabled={row.isReadOnly}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Dólares',
                        dataIndex: 'dolares',
                        key: 'dolares',
                        align: 'left',
                        width: 150,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrDolares[${row.id}]`, {
                                        initialValue: value,
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_3DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Lote"
                                            autoComplete="off"
                                            className="text-left"
                                            onBlur={(e) => props.onCalculateServicio(row.id, "arrDolares", e.target.value, 3, row.id)}
                                            disabled={row.isReadOnly}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    }
                    
                ]}

            />
        </div>

    )


}